import React from 'react';
import useAuthenticationRedirect from 'hooks/useAuthentication';
import { Loader } from '@dekafvv/sharedfrontend';

interface WithAuthenticationProps {
    children: React.ReactNode | React.ReactNode[] | null;
}

const WithAuthentication = ({
    children,
}: WithAuthenticationProps) => {
    const { isLoading } = useAuthenticationRedirect();

    if (isLoading) return <Loader />;

    return (
        <>
            {children}
        </>
    );
};

export default WithAuthentication;
